// extracted by mini-css-extract-plugin
module.exports = {"root":"Slider_root__F7Igt","track":"Slider_track__C2VUF","range":"Slider_range__fXfi5","thumb":"Slider_thumb__s3mT8"};